import {get} from 'lodash-es';
import moment from 'moment/moment';

import {TEntityValue} from 'modules/data';

import {pathInStringStructure} from '../regular-expressions';

/**
 * Заменяет заполнители в строке stringStructure на значения из аргумента value
 *
 * @param {string} stringStructure - Строка, содержащая ключи для замены значений.
 * @param {TEntityValue} value - Объект, содержащий значения, которые будут подставлены в строку.
 * @param {string} [dateFormat] - Формат даты для преобразования значений даты (опционально).
 * @returns {string} - Итоговая строка с заменёнными значениями.
 *
 * @description
 * Принимает строковую структуру cо специальными заполнителями (например, {key})
 * и заменяет их значениями, извлеченными из переданного объекта value по указанным ключам
 * Если значение отсутствует или пустое, заполнитель заменяется пустой строкой.
 * Если значение является датой и передан параметр dateFormat, дата форматируется в соответствии с указанным форматом.
 */
export const combineString = (stringStructure: string, value: TEntityValue, dateFormat?: string) => {
    const valueKeys = stringStructure.match(pathInStringStructure('g'));
    return valueKeys?.reduce((finalString: string, valueKey: string) => {
        let finalText = get(value, valueKey, '');
        if (finalText == null || (typeof finalText === 'string' && !finalText.length)) {
            return finalString.replace(valueKey, '');
        }
        if (Date.parse(finalText) && dateFormat) {
            finalText = moment(finalText).format(dateFormat);
        }
        return finalString.replace(valueKey, finalText);
    }, stringStructure);
};
